import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import api from '../lib/api';
import { formatDate } from '../lib/format';

const BlogPostPage = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    (async () => {
      try {
        const res = await api.get(`/blogs/${slug}`);
        if (cancelled) return;
        if (res.data?.success) setPost(res.data.data);
        else setError('Post not found');
      } catch (err) {
        if (cancelled) return;
        setError(err.response?.data?.message || 'Failed to load post');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [slug]);

  if (loading) {
    return (
      <div className="max-w-3xl mx-auto p-12 animate-pulse">
        <div className="h-12 bg-gray-200 mb-4" />
        <div className="h-4 bg-gray-200 w-1/3 mb-8" />
        <div className="space-y-2">
          <div className="h-4 bg-gray-200" />
          <div className="h-4 bg-gray-200" />
          <div className="h-4 bg-gray-200 w-2/3" />
        </div>
      </div>
    );
  }

  if (error || !post) {
    return (
      <div className="max-w-2xl mx-auto p-12 text-center">
        <h2 className="text-3xl font-black mb-4">POST NOT FOUND</h2>
        <p className="text-gray-600 mb-6">{error}</p>
        <Link to="/blog" className="inline-flex items-center gap-2 bg-black text-white px-6 py-3 font-black uppercase">
          <ArrowLeft size={18} /> Back to Journal
        </Link>
      </div>
    );
  }

  return (
    <article className="max-w-3xl mx-auto p-6 md:p-12">
      <Link to="/blog" className="inline-flex items-center gap-2 text-sm font-bold mb-6 hover:underline">
        <ArrowLeft size={16} /> Back to Journal
      </Link>
      <div className="bg-black text-white inline-block px-3 py-1 text-xs font-black uppercase tracking-widest mb-4">
        {post.category}
      </div>
      <h1 className="text-4xl md:text-6xl font-black leading-[0.95] mb-3">{post.title}</h1>
      <div className="text-sm font-mono text-gray-500 mb-8">{formatDate(post.publishedAt)}</div>
      {post.coverImage?.url && (
        <img src={post.coverImage.url} alt={post.title} className="w-full border-4 border-black mb-8" />
      )}
      <div
        className="prose prose-lg max-w-none font-mono leading-relaxed"
        dangerouslySetInnerHTML={{ __html: post.content || post.excerpt || '' }}
      />
    </article>
  );
};

export default BlogPostPage;
